module.exports = __webpack_public_path__ + "public/images/about-exhibition/bg-tablet-h.e0d3b6e362125221d712f646a0a9058e.svg";